import React, { useState } from 'react'
import { useMOLineageSourceSummary } from '../../hooks/queries/sourceSummary'
import SourceAccordians from './components/SourceAccordian/SourceAccordians'
import MoLineageSourceData from './sections/MoLineageSourceData'
import MOLineageTable from '../sourceData/components/MOLineageTable'
import { useQueryClient } from 'react-query'
import Loading from '../../components/Loading'
import { useAuth0 } from '@auth0/auth0-react'
import { useAllMOLineage } from '../../hooks/queries/allMoLineage'

export default function MoLineagePage() {
  const [sheetData, setSheetData] = useState({})
  const [expanded, setExpanded] = useState(false)

  const sourceSummaryType = 'moLineageSummary'
  const sourceSummaryQueryKey = 'moLineageSourceSummary'
  const dataSummaryQueryKey = 'moLineageTable'
  const pageDataType = 'moLineage'

  const { isFetching: iFSourceData } = useMOLineageSourceSummary(sourceSummaryQueryKey, sourceSummaryType, {
    setSheetData,
  })

  const { user } = useAuth0()
  const {
    isLoading: iLTableData,
    isErroxr: iETableData,
    isFetching: iFTableData,
    data: moLineageTableData,
  } = useAllMOLineage(dataSummaryQueryKey, user?.email)

  const queryClient = useQueryClient()
  const refetchData = () => {
    queryClient.refetchQueries([sourceSummaryQueryKey])
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const setExpand = (val) => {
    setExpanded(val)
  }

  const sourceDataSources = iFSourceData
    ? []
    : [<MoLineageSourceData refetchData={refetchData} uploadSummary={sheetData} key={0} setExpand={setExpand} />]

  const clearSheetData = () => {
    setSheetData({})
  }

  const tableData = iLTableData || iETableData || iFTableData ? [] : moLineageTableData

  return (
    <>
      {iFSourceData ? (
        <Loading />
      ) : (
        <SourceAccordians
          label={'MO Lineage'}
          sources={sourceDataSources}
          refetchData={refetchData}
          clearSheetData={clearSheetData}
          displayComp={<MOLineageTable data={tableData} />}
          sourceSummaryQueryKey={sourceSummaryQueryKey}
          dataSummaryQueryKey={dataSummaryQueryKey}
          pageDataType={pageDataType}
          toExpand={expanded}
        />
      )}
    </>
  )
}
